import enviro from 'enviro';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { Data } from '../signup-data/DATA';
import { codeVerificationStart } from '../store/step-code-verification/action-creators';
import { CodeVerificationActionTypes } from '../store/step-code-verification/action-types';
import { Step } from './Step';
import { StepConfigFactory } from './StepConfigFactory';
import { getStepView } from './StepViews';
export const StepConfigs = new Map(); // ----------
// Registration of buttons only steps.
// ----------

[{
  step: Step.CompanySize,
  data: [Data.CompanySize]
}, {
  step: Step.CrmExperienceLevel,
  data: [Data.CrmExperienceLevel]
}, {
  step: Step.JobField,
  data: [Data.JobField]
}, {
  step: Step.UseCase,
  data: [Data.UseCase]
}].forEach(({
  step,
  data
}) => {
  StepConfigs.set(step, StepConfigFactory.getStepConfig(step, data, getStepView(step), {
    trackSelectedOption: true
  }));
}); // ----------
// Registration of error steps
// ----------

[Step.EmailVerificationNotFound, Step.InternalError, Step.LoginFailed, Step.StandardCreationError, Step.VerifyFirstCreationError, Step.RateLimitedCreationError, Step.OAuthExistingLoginFailed, Step.OAuthPendingEmailVerification, Step.RateLimitedEmailVerification, Step.EmailVerificationFailed, Step.SessionExpired, Step.ExistingAccountsFetchFailed, Step.RecaptchaCreationError, Step.PartnerExistingAccountError, Step.AlreadyAPartner, Step.WordpressAuthorizationError, Step.BlankScreenLoadingError, Step.PartnerNoRegisteredLeads, Step.NoPartnerPortalsError, Step.EmbeddedSignupContinueScreen].forEach(errorStep => StepConfigs.set(errorStep, StepConfigFactory.getStepConfig(errorStep, [], getStepView(errorStep), {
  hideBackButton: true,
  isWideStep: true
}))); // ----------
// Registration of singular steps
// ----------

StepConfigs.set(Step.LandingPage, StepConfigFactory.getStepConfig(Step.LandingPage, [Data.FirstName, Data.LastName, Data.Email], getStepView(Step.LandingPage), {
  hideStepNumber: true,
  hideProgressBar: true,
  shouldShowPrivacyBanner: true
}));
StepConfigs.set(Step.EmailOnlyLandingPage, StepConfigFactory.getStepConfig(Step.EmailOnlyLandingPage, [Data.Email], getStepView(Step.EmailOnlyLandingPage), {
  hideStepNumber: true,
  hideProgressBar: true,
  shouldShowPrivacyBanner: true
}));
StepConfigs.set(Step.Name, StepConfigFactory.getStepConfig(Step.Name, [Data.FirstName, Data.LastName], getStepView(Step.Name)));
StepConfigs.set(Step.Industry, StepConfigFactory.getStepConfig(Step.Industry, [Data.Industry], getStepView(Step.Industry)));
StepConfigs.set(Step.JobRole, StepConfigFactory.getStepConfig(Step.JobRole, [Data.JobRole], getStepView(Step.JobRole), {
  trackSelectedOption: true
}));
StepConfigs.set(Step.Verification, StepConfigFactory.getStepConfig(Step.Verification, [Data.Verification], getStepView(Step.Verification), {
  hideBackButton: true
}));
StepConfigs.set(Step.UnauthedPartnerUserError, StepConfigFactory.getStepConfig(Step.UnauthedPartnerUserError, [], getStepView(Step.UnauthedPartnerUserError), {
  hideBackButton: true,
  hideProgressBar: true,
  isWideStep: true
}));
StepConfigs.set(Step.ResendEmail, StepConfigFactory.getStepConfig(Step.ResendEmail, [Data.Email], getStepView(Step.ResendEmail)));
StepConfigs.set(Step.Password, StepConfigFactory.getStepConfig(Step.Password, [Data.Password], getStepView(Step.Password), {
  hideBackButton: true
}));
StepConfigs.set(Step.MobileAppPrompt, StepConfigFactory.getStepConfig(Step.MobileAppPrompt, [], getStepView(Step.MobileAppPrompt), {
  hideBackButton: true,
  isWideStep: true
}));
StepConfigs.set(Step.ExistingUser, StepConfigFactory.getStepConfig(Step.ExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.ExistingUser), {
  hideProgressBar: true,
  hideBackButton: true,
  isWideStep: true
}));
StepConfigs.set(Step.ExistingAccounts, StepConfigFactory.getStepConfig(Step.ExistingAccounts, [], getStepView(Step.ExistingAccounts), {
  hideProgressBar: true,
  isWideStep: true
}));
StepConfigs.set(Step.HublessNoAccount, StepConfigFactory.getStepConfig(Step.HublessNoAccount, [], getStepView(Step.HublessNoAccount), {
  hideProgressBar: true,
  isWideStep: true
}));
StepConfigs.set(Step.FirstName, StepConfigFactory.getStepConfig(Step.FirstName, [Data.FirstName], getStepView(Step.FirstName)));
StepConfigs.set(Step.LastName, StepConfigFactory.getStepConfig(Step.LastName, [Data.LastName], getStepView(Step.LastName)));
StepConfigs.set(Step.CompanyDomain, StepConfigFactory.getStepConfig(Step.CompanyDomain, [Data.CompanyDomain], getStepView(Step.CompanyDomain)));
StepConfigs.set(Step.CompanyName, StepConfigFactory.getStepConfig(Step.CompanyName, [Data.CompanyName], getStepView(Step.CompanyName)));
StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.CompanyDomain], getStepView(Step.IntegrationsAccountCreated), {
  hideBackButton: true
}));
StepConfigs.set(Step.WordpressAuthorization, StepConfigFactory.getStepConfig(Step.WordpressAuthorization, [Data.WordpressRecaptchaToken], getStepView(Step.WordpressAuthorization), {
  hideBackButton: true
}));
StepConfigs.set(Step.CodeVerification, Object.assign({}, StepConfigFactory.getStepConfig(Step.CodeVerification, [Data.CodeVerification], getStepView(Step.CodeVerification), {
  hideBackButton: true
}), {
  beforeComplete: dispatch => dispatch(codeVerificationStart()),
  stepCompletedAction: CodeVerificationActionTypes.Success
}));
StepConfigs.set(Step.HubInterest, StepConfigFactory.getStepConfig(Step.HubInterest, [Data.HubInterest], getStepView(Step.HubInterest), {
  trackSelectedOption: true
}));
StepConfigs.set(Step.AcademyEmbeddedExistingUser, StepConfigFactory.getStepConfig(Step.AcademyEmbeddedExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.AcademyEmbeddedExistingUser), {
  trackSelectedOption: true,
  isWideStep: true
}));
StepConfigs.set(Step.HubletSelection, StepConfigFactory.getStepConfig(Step.HubletSelection, [Data.HubletSelection], getStepView(Step.HubletSelection), {
  trackSelectedOption: true
}));
StepConfigs.set(Step.Country, StepConfigFactory.getStepConfig(Step.Country, [Data.Country], getStepView(Step.Country), {
  trackSelectedOption: true
}));
StepConfigs.set(Step.PhoneNumber, StepConfigFactory.getStepConfig(Step.PhoneNumber, [Data.PhoneNumber], getStepView(Step.PhoneNumber)));
StepConfigs.set(Step.CmsPartnerCompanyDomainAndName, StepConfigFactory.getStepConfig(Step.CmsPartnerCompanyDomainAndName, [Data.CompanyDomain, Data.CompanyName], getStepView(Step.CmsPartnerCompanyDomainAndName)));
StepConfigs.set(Step.OptionalPhoneNumber, StepConfigFactory.getStepConfig(Step.OptionalPhoneNumber, [Data.OptionalPhoneNumber], getStepView(Step.OptionalPhoneNumber)));
StepConfigs.set(Step.CmsExistingUser, StepConfigFactory.getStepConfig(Step.CmsExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.CmsExistingUser), {
  hideProgressBar: true,
  hideBackButton: true,
  isWideStep: true
}));
StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.IntegrationsAccountCreatedCheck], getStepView(Step.IntegrationsAccountCreated), {
  hideBackButton: true,
  isWideStep: true
})); // TODO remove after running ONBF-016

StepConfigs.set(Step.UseCase, StepConfigFactory.getStepConfig(Step.UseCase, [Data.UseCase], getStepView(Step.UseCase)));
StepConfigs.set(Step.InstallSalesExtension, StepConfigFactory.getStepConfig(Step.InstallSalesExtension, [Data.InstallSalesExtension], getStepView(Step.InstallSalesExtension)));
StepConfigs.set(Step.TrackEmail, StepConfigFactory.getStepConfig(Step.TrackEmail, [Data.TrackEmail], getStepView(Step.TrackEmail)));
StepConfigs.set(Step.TrackEmailConfirmation, StepConfigFactory.getStepConfig(Step.TrackEmailConfirmation, [Data.TrackEmailConfirmation], getStepView(Step.TrackEmailConfirmation)));
StepConfigs.set(Step.ContinueToAccount, StepConfigFactory.getStepConfig(Step.ContinueToAccount, [Data.ContinueToAccount], getStepView(Step.ContinueToAccount))); // Local development information

if (enviro.isQa() && !enviro.deployed()) {
  const allSteps = Object.values(Step);
  const registeredSteps = Array.from(StepConfigs.keys());
  const allDataAndError = [...Object.values(Data), ...Object.values(ErrorKey)];
  const notIncludedInConfig = allDataAndError.filter(x => !registeredSteps.includes(x));
  const notRegistered = allSteps.filter(x => !registeredSteps.includes(x));
  /* eslint-disable no-console */

  console.group('StepConfigs Debug Information');
  console.info(`Data points or error keys not included as a step config`, notIncludedInConfig);
  console.info(`Steps not registered`, notRegistered);
  console.groupEnd();
}